/** Strings for shared opening-hours schedules, holidays and closures (#1256, #1231). */
export const translationLivechat_en_schedules = {
  livechatOpeningHours: "Opening hours",
  livechatOpeningHoursHint: "Schedules, holidays and closures shared by chatbots",
  livechatHolidaysClosures: "Holidays & special hours",
  livechatSchedulesDescription:
    "Each chatbot follows one schedule or keeps its own hours. A change applies to every chatbot on the schedule at once.",
  livechatSchedulesEmpty: "No schedules yet. Create one and choose which chatbots follow it.",
  livechatSchedulesLoadFailed: "Could not load the schedules.",
  livechatScheduleNew: "New schedule",
  livechatScheduleNewName: "New schedule",
  livechatScheduleName: "Schedule name",
  livechatScheduleTimezone: "Time zone",
  livechatScheduleChatbotCount: "{count} chatbots",
  livechatScheduleClosureCount: "{count} upcoming closures",
  livechatScheduleNoClosures: "No closures",
  livechatScheduleClosedNow: "Closed now: {name}",
  livechatScheduleTabWeekly: "Weekly hours",
  livechatScheduleTabClosures: "Holidays & special hours",
  livechatScheduleTabChatbots: "Chatbots",
  livechatScheduleSave: "Save schedule",
  livechatScheduleSaving: "Saving…",
  livechatScheduleDelete: "Delete schedule",
  livechatScheduleDeleteConfirm:
    "Delete “{name}”? Its chatbots keep its weekly hours as their own. Its holidays and closures are deleted.",
  livechatScheduleDeleteConfirmAction: "Delete",
  livechatScheduleAll: "All schedules",
  livechatScheduleNameTaken: "A schedule with this name already exists.",
  livechatScheduleSaveFailed: "Could not save the schedule.",
  livechatScheduleChatbotsHelp:
    "Ticking a chatbot that follows another schedule moves it here. A chatbot you untick keeps this schedule’s hours as its own.",
  livechatScheduleChatbotsSave: "Save chatbots",
  livechatScheduleOnOther: "On {name}",
  livechatScheduleSelected: "{count} of {total} chatbots follow this schedule",
  livechatScheduleUnsaved: "Unsaved changes",
  livechatClosureAdd: "Add closure",
  livechatClosureEdit: "Edit closure",
  livechatClosureUpcoming: "Upcoming",
  livechatClosurePast: "Past",
  livechatClosureShow: "Show",
  livechatClosureEmpty: "Nothing planned. Add a closure or special opening hours for given dates.",
  livechatClosurePastEmpty: "No past closures or special hours.",
  livechatClosureName: "Name",
  livechatClosureStart: "Start date",
  livechatClosureEnd: "End date",
  livechatClosureRepeat: "Repeat every year",
  livechatClosureHours: "Hours on these dates",
  livechatClosureClosedAllDay: "Closed all day",
  livechatClosureCustomHours: "Special opening hours",
  livechatClosureCustomHelp: "Live chat is open only in these time slots on these dates.",
  livechatClosureClosedHelp: "Live chat is closed the whole day. The chatbot keeps answering.",
  livechatClosureAddSlot: "Add time slot",
  livechatClosureSlotStart: "Slot {index} opens",
  livechatClosureSlotEnd: "Slot {index} closes",
  livechatClosureSlotRemove: "Remove slot {index}",
  livechatClosureMessage: "Message when a visitor asks for live chat",
  livechatClosureRegularMessage: "Regular closed message",
  livechatClosureOwnMessage: "Own message",
  livechatClosureRegularHelp: "The bot uses each contact form’s regular closed message.",
  livechatClosureOwnLabel: "Own message",
  livechatClosureInsert: "Insert",
  livechatClosurePreview: "Text the bot uses on {date}",
  livechatClosureSave: "Save",
  livechatClosureDelete: "Delete closure",
  livechatClosureDeleteConfirm: "Delete “{name}”?",
  livechatClosureEveryYear: "Every year",
  livechatClosureActive: "Active now",
  livechatClosureAllDay: "All day",
  livechatClosureClosed: "Closed",
  livechatClosureCustom: "Open {hours}",
  livechatClosureOwnShort: "Own message",
  livechatClosureRegularShort: "Regular message",
  livechatClosureOptions: "Options for {name}",
  livechatClosureSaveFailed: "Could not save the closure.",
  livechatClosureInvalid:
    "Check the dates and times: the end date must be on or after the start date and at most a year later, and slots must not overlap.",
  livechatClosureLimit: "This schedule already has the most closures it can have.",
  livechatSettingsSchedule: "Opening hours",
  livechatSettingsScheduleCustom: "Custom for this chatbot",
  livechatSettingsScheduleFollowing:
    "Follows “{name}”. Editing the schedule changes all {count} chatbots on it.",
  livechatSettingsScheduleEdit: "Edit schedule",
  livechatSettingsScheduleShare: "Share these hours as a schedule",
  livechatSettingsScheduleShareHint:
    "Holidays and closures belong to schedules. Create one from these hours to add them.",
  livechatSettingsScheduleSaveFailed: "Could not change the schedule.",
  livechatAvailabilityClosedFor: "{name} until {time}",
  livechatScheduleNameRequired: "Give the schedule a name.",
  livechatScheduleTimezoneInvalid:
    "Unknown time zone. Pick one from the list, e.g. Europe/Copenhagen.",
  livechatScheduleDiscardTitle: "Discard your changes?",
  livechatScheduleDiscardText: "You have changes to this schedule that are not saved.",
  livechatScheduleKeepEditing: "Keep editing",
  livechatScheduleDiscard: "Discard",
  livechatScheduleReplacesOwnHours:
    "{count} of the selected chatbots have their own hours. When you save, they get the schedule's hours instead, and their own hours cannot be restored.",
  livechatSettingsScheduleReplacesOwnHours:
    "When you save, the chatbot gets the schedule's hours instead of its own. Its own hours cannot be restored.",
  livechatClosureNameRequired: "Give the closure a name.",
  livechatClosureDatesInvalid:
    "The end date must be on or after the start date and at most a year later.",
  livechatClosureNoSlots: "Add at least one time slot, or choose Closed all day.",
  livechatClosureSlotsInvalid:
    "Each time slot must end after it starts, and slots must not overlap.",
  livechatScheduleSelectAll: "Select all",
  livechatScheduleSaved: "“{name}” saved.",
  livechatScheduleChatbotsSaved: "Chatbots saved.",
  livechatClosureSaved: "Closure saved.",
  livechatSpecialHoursSaved: "Special opening hours saved.",
  livechatSpecialHoursAdd: "Add special hours",
  livechatSpecialHoursEdit: "Edit special hours",
  livechatScheduleNoChatbots: "No chatbots follow this schedule yet, so its hours are not used.",
  livechatScheduleChooseChatbots: "Choose chatbots",
  livechatTimezoneSearch: "Search time zones",
  livechatTimezoneEmpty: "No time zone found.",
};
